(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["character-dark-hero"] && !Shopify.designMode) return;
  try {
    
  /* Charakter im Dunkeln v6.
     Alle Größen: Licht geht beim Laden langsam an (Dimmer), Blinzeln gleich zu Beginn und danach selten, Pfeil zur
     nächsten Section. Computer: Augen folgen der Maus, Tiefe und Licht folgen der Maus, Maske für die Dunkelheit des
     Charakters. Handy: kein transform auf Bildern, Dunkelheit des Charakters über seine Deckkraft.
     Gerechnet wird nur im requestAnimationFrame, die Schleife hält an, sobald nichts mehr in Bewegung ist. */
  (() => {
    if (window.__cdh6) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    const narrow = matchMedia('(max-width: 699px)');
    const items = new Set();
    let frame = 0;
    let pointer = null;

    const REST = 0.42;            // Ruhelicht, Anteil von „Helligkeit des Lichts“
    const RISE = [450, 2050];     // Licht geht an (ms)
    const SETTLE = [2450, 3900];  // pendelt sich auf das Ruhelicht ein
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const lightAt = (t) => {
      if (t <= RISE[0]) return 0;
      if (t <= RISE[1]) return easeInOut((t - RISE[0]) / (RISE[1] - RISE[0]));
      if (t <= SETTLE[0]) return 1;
      if (t <= SETTLE[1]) return 1 - easeInOut((t - SETTLE[0]) / (SETTLE[1] - SETTLE[0])) * (1 - REST);
      return REST;
    };

    // Handy: alle Bewegungen der Ebenen zurücksetzen (einmal beim Wechsel)
    const still = (it) => {
      [it.char, it.eyesBox, it.fx, it.room, it.type, it.fore].forEach((e) => { if (e) e.style.transform = ''; });
      it.pupils.forEach((p) => { p.style.transform = ''; });
      it.eyePos.forEach((s) => { s.x = 0; s.y = 0; });
      it.par.x = 0;
      it.par.y = 0;
    };

    const render = (it, now) => {
      const mob = narrow.matches;
      let moving = false;
      let light = REST;
      if (!it.still) {
        if (!it.t0) light = 0;
        else {
          const t = now - it.t0;
          light = lightAt(t);
          if (t < SETTLE[1]) moving = true;
        }
      }

      if (mob !== it.mob) { it.mob = mob; it.lastLight = -1; if (mob) still(it); }

      // Licht nur schreiben, solange es sich ändert
      if (light !== it.lastLight) {
        it.lastLight = light;
        const dark = it.dark * (1 - light * it.bright);
        const d = dark.toFixed(3);
        it.darkLayer.style.opacity = d;
        if (it.shade) it.shade.style.opacity = d;
        // Handy: Dunkelheit über die Deckkraft des Charakterbilds, Computer: über die Maske (CSS-Wert bleibt frei)
        if (it.base) it.base.style.opacity = mob ? (1 - dark).toFixed(3) : '';
        if (it.foreShade) it.foreShade.style.opacity = d;
        if (it.foreLit) it.foreLit.style.opacity = (light * it.bright * 0.9).toFixed(3);
        it.lightLayer.style.opacity = (light * it.bright * 0.7).toFixed(3);
        if (it.beam) it.beam.style.opacity = (light * (0.55 + it.bright * 0.45)).toFixed(3);
      }

      if (mob) {
        it.lightLayer.style.transform = `scale(${(0.85 + light * 0.3).toFixed(3)})`;
        return moving;
      }

      // Ab hier nur Computer und Tablet
      const boxes = it.track && pointer ? it.eyes.map((e) => e.getBoundingClientRect()) : [];
      if (it.parallax) {
        const tx = pointer ? (pointer.x / innerWidth - 0.5) * 2 : 0;
        const ty = pointer ? (pointer.y / innerHeight - 0.5) * 2 : 0;
        it.par.x += (tx - it.par.x) * 0.08;
        it.par.y += (ty - it.par.y) * 0.08;
        if (Math.abs(tx - it.par.x) > 0.002 || Math.abs(ty - it.par.y) > 0.002) moving = true;
        else { it.par.x = tx; it.par.y = ty; }
      }
      const px = it.par.x;
      const py = it.par.y;
      it.lightLayer.style.transform = `translate3d(${(px * innerWidth * 0.07).toFixed(1)}px, ${(py * innerHeight * 0.05).toFixed(1)}px, 0) scale(${(0.85 + light * 0.3).toFixed(3)})`;
      const charT = `translate3d(${(-px * 14).toFixed(2)}px, ${(-py * 8).toFixed(2)}px, 0) scale(${(1 + light * 0.02).toFixed(4)})`;
      it.char.style.transform = charT;
      if (it.eyesBox) it.eyesBox.style.transform = charT;
      if (it.fx) it.fx.style.transform = charT;
      if (it.room) it.room.style.transform = `translate3d(${(-px * 5).toFixed(2)}px, ${(-py * 3).toFixed(2)}px, 0) scale(1.015)`;
      if (it.type) it.type.style.transform = `translate3d(${(-px * 8).toFixed(2)}px, ${(-py * 5).toFixed(2)}px, 0)`;
      if (it.fore) it.fore.style.transform = `translate3d(${(-px * 26).toFixed(2)}px, ${(-py * 10).toFixed(2)}px, 0)`;

      // Augen folgen dem Zeiger, begrenzt auf „Maximale Augenbewegung“
      if (it.track && it.pupils.length) {
        it.pupils.forEach((pupil, i) => {
          let tx = 0;
          let ty = 0;
          if (pointer) {
            const b = boxes[i];
            const vx = pointer.x - (b.left + b.width * it.eyeX[i]);
            const vy = pointer.y - (b.top + b.height * it.eyeY);
            const dist = Math.hypot(vx, vy) || 1;
            const reach = Math.min(1, dist / (Math.min(innerWidth, innerHeight) * 0.45));
            tx = (vx / dist) * it.max * reach;
            ty = (vy / dist) * it.max * reach * 0.7;
          }
          const s = it.eyePos[i];
          s.x += (tx - s.x) * 0.12;
          s.y += (ty - s.y) * 0.12;
          if (Math.abs(tx - s.x) > 0.02 || Math.abs(ty - s.y) > 0.02) moving = true;
          pupil.style.transform = `translate3d(${s.x.toFixed(2)}px, ${s.y.toFixed(2)}px, 0)`;
        });
      }
      return moving;
    };

    const tick = (now) => {
      frame = 0;
      let again = false;
      items.forEach((it) => { if (it.visible && render(it, now)) again = true; });
      if (again) frame = requestAnimationFrame(tick);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(tick); };

    // Blinzeln: einmal gleich am Anfang, danach selten und unregelmäßig, manchmal doppelt
    const blinkOnce = (it) => {
      const kf = [{ transform: 'scaleY(1)' }, { transform: 'scaleY(.06)', offset: 0.45 }, { transform: 'scaleY(1)' }];
      it.eyes.forEach((e) => e.animate(kf, { duration: 170, easing: 'ease-in-out' }));
    };
    const blink = (it, delay) => {
      clearTimeout(it.blinkTimer);
      if (!it.blink || reduce.matches) return;
      it.blinkTimer = setTimeout(() => {
        if (it.visible && document.visibilityState === 'visible') {
          blinkOnce(it);
          if (Math.random() < 0.25) setTimeout(() => blinkOnce(it), 260);
        }
        blink(it, 3200 + Math.random() * 5200);
      }, delay);
    };

    // Start, sobald der Charakter geladen und die Section im Bild ist. Läuft einmal pro Seitenaufruf
    const start = (it) => {
      if (it.started || !it.visible || !it.ready) return;
      it.started = true;
      if (!it.still) it.t0 = performance.now();
      blink(it, 400);
      schedule();
    };

    // Computer: Maske laden, dann den Charakter zeigen (auf dem Handy wird sie nicht gebraucht)
    const loadMask = (it) => {
      const url = it.el.dataset.cdhMask;
      if (!url || it.maskLoading || narrow.matches) return;
      it.maskLoading = true;
      const im = new Image();
      im.src = url;
      const done = () => it.el.classList.add('is-masked');
      (im.decode ? im.decode() : new Promise((r, j) => { im.onload = r; im.onerror = j; })).then(done, done);
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const it = [...items].find((x) => x.el === en.target);
        if (!it) return;
        it.visible = en.isIntersecting;
        it.el.classList.toggle('is-visible', it.visible);
        if (it.visible) { start(it); schedule(); }
      });
    }, { threshold: 0.2 });

    // Pfeil: weich zur nächsten Section, mit Platz für den klebenden Header
    const goDown = (el) => {
      const head = parseFloat(getComputedStyle(el).getPropertyValue('--cdh-top')) || 0;
      const y = el.getBoundingClientRect().bottom + scrollY - head;
      window.scrollTo({ top: y, behavior: reduce.matches ? 'auto' : 'smooth' });
    };

    const bind = (scope = document) => {
      scope.querySelectorAll('[data-cdh]:not([data-cdh-ready])').forEach((el) => {
        el.setAttribute('data-cdh-ready', '');
        const title = el.querySelector('.cdh__title');
        if (title) {
          const fitT = () => { const W = title.clientWidth; if (!W) return; title.style.fontSize = ''; title.classList.add('is-fit'); let fs = parseFloat(getComputedStyle(title).fontSize); for (let i = 0; i < 40 && title.scrollWidth > W + 1; i++) { fs *= 0.95; title.style.fontSize = fs.toFixed(2) + 'px'; } };
          fitT();
          if ('ResizeObserver' in window) new ResizeObserver(fitT).observe(title);
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitT);
        }
        const eyes = [...el.querySelectorAll('[data-cdh-eye]')];
        const motion = !reduce.matches;
        const it = {
          el,
          char: el.querySelector('[data-cdh-char]'),
          base: el.querySelector('[data-cdh-char] img'),
          shade: el.querySelector('[data-cdh-shade]'),
          eyesBox: el.querySelector('[data-cdh-eyes]'),
          fx: el.querySelector('[data-cdh-fx]'),
          room: el.querySelector('[data-cdh-room]'),
          type: el.querySelector('[data-cdh-type]'),
          fore: el.querySelector('[data-cdh-fore]'),
          foreLit: el.querySelector('[data-cdh-forelit]'),
          foreShade: el.querySelector('[data-cdh-foreshade]'),
          beam: el.querySelector('[data-cdh-beam]'),
          darkLayer: el.querySelector('[data-cdh-darklayer]'),
          lightLayer: el.querySelector('[data-cdh-light]'),
          eyes,
          pupils: eyes.map((e) => e.querySelector('img')).filter(Boolean),
          eyePos: [{ x: 0, y: 0 }, { x: 0, y: 0 }],
          eyeX: eyes.map((e) => (parseFloat(e.style.getPropertyValue('--ex')) || 50) / 100),
          eyeY: ((parseFloat((eyes[0] || el).style.getPropertyValue('--ey')) || 30) / 100),
          bright: clamp(parseFloat(el.dataset.cdhBright) || 0.6, 0, 1),
          dark: clamp(parseFloat(el.dataset.cdhDark) || 0.94, 0, 1),
          max: parseFloat(el.dataset.cdhMax) || 8,
          still: !motion || el.dataset.cdhMode === 'static',
          track: el.dataset.cdhTrack === '1' && finePointer.matches && motion,
          parallax: finePointer.matches && motion,
          par: { x: 0, y: 0 },
          blink: el.dataset.cdhBlink === '1',
          t0: 0,
          lastLight: -1,
          mob: null,
          visible: false
        };
        el.style.setProperty('--cdh-phase', `${(-Math.random() * 5).toFixed(2)}s`);
        items.add(it);
        loadMask(it);
        el.querySelector('[data-cdh-down]')?.addEventListener('click', () => goDown(el));
        // Erstes Bild zuerst: Bewegung erst im nächsten Frame
        requestAnimationFrame(() => {
          if (motion) el.classList.add('is-live');
          render(it, performance.now());
          io.observe(el);
        });
        // Bereit, wenn das Charakterbild dekodiert ist (spätestens nach 1,5 s)
        const ready = () => { if (it.ready) return; it.ready = true; start(it); };
        if (it.base && it.base.decode) Promise.race([it.base.decode(), new Promise((r) => setTimeout(r, 1500))]).then(ready, ready);
        else ready();
      });
    };

    const unbind = (scope) => {
      items.forEach((it) => {
        if (!scope.contains(it.el)) return;
        clearTimeout(it.blinkTimer);
        io.unobserve(it.el);
        items.delete(it);
      });
    };

    addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      pointer = { x: e.clientX, y: e.clientY };
      schedule();
    }, { passive: true });
    addEventListener('pointerout', (e) => { if (!e.relatedTarget) { pointer = null; schedule(); } }, { passive: true });
    // Drehen oder Fenster ändern: Layout wechselt zwischen Handy und Computer
    narrow.addEventListener?.('change', () => { items.forEach((it) => { loadMask(it); }); schedule(); });

    window.__cdh6 = { bind };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
    else bind();
    document.addEventListener('shopify:section:load', (e) => bind(e.target));
    document.addEventListener('shopify:section:unload', (e) => unbind(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcBa) return;
    window.__dcBa = true;

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;
      const view = sec.querySelector('[data-dc-ba-view]');
      const knob = sec.querySelector('[data-dc-ba-knob]');
      const tabs = [...sec.querySelectorAll('[data-dc-ba-to]')];
      let pos = parseFloat(getComputedStyle(view).getPropertyValue('--pos')) || 50;
      let drag = false, x0 = 0, moved = false;

      const set = (p, glide) => {
        pos = Math.round(Math.max(0, Math.min(100, p)));
        sec.classList.toggle('is-glide', !!glide);
        view.style.setProperty('--pos', pos + '%');
        knob.setAttribute('aria-valuenow', pos);
        sec.classList.toggle('is-l-hidden', pos <= 12);
        sec.classList.toggle('is-r-hidden', pos >= 88);
        tabs.forEach((t) => t.setAttribute('aria-pressed', String(Number(t.dataset.dcBaTo) === pos)));
      };
      const at = (e) => { const r = view.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; };

      view.addEventListener('pointerdown', (e) => { if (e.button) return; drag = true; moved = false; x0 = e.clientX; view.setPointerCapture(e.pointerId); sec.classList.add('is-drag'); });
      view.addEventListener('pointermove', (e) => { if (!drag) return; if (Math.abs(e.clientX - x0) > 4) moved = true; if (moved) set(at(e), false); });
      const up = (e) => { if (!drag) return; drag = false; sec.classList.remove('is-drag'); if (!moved) set(at(e), true); };
      view.addEventListener('pointerup', up);
      view.addEventListener('pointercancel', () => { drag = false; sec.classList.remove('is-drag'); });
      knob.addEventListener('keydown', (e) => {
        const map = { ArrowLeft: pos - 5, ArrowRight: pos + 5, Home: 0, End: 100 };
        if (e.key in map) { e.preventDefault(); set(map[e.key], true); }
      });
      tabs.forEach((t) => t.addEventListener('click', () => set(Number(t.dataset.dcBaTo), true)));
      set(pos, false);
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-ba]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-contact"] && !Shopify.designMode) return;
  try {
    
  /* Gemeinsame Anfrage-Bühne (dc-quick-contact, dc-request, dc-contact): Formen springen ein und schweben, Pause-Taste,
     Prüfen am Feld, Sende-Zustand und Herkunft der Anfrage. Steht gleich in allen drei Sections, weil Shopify das Skript
     einer Section nur auf Seiten lädt, auf denen sie vorkommt. Läuft nur einmal pro Seite. */
  (() => {
    if (window.__dcQc2) return;
    window.__dcQc2 = true;

    // Herkunft: Kampagne aus dem Link (utm_*), sonst die fremde Seite, von der man kam. Bleibt für den Besuch gespeichert
    // (sessionStorage, nur diese drei Werte, nichts Persönliches), damit sie auch auf einer späteren Seite mitgeht.
    const source = (() => {
      try {
        const q = new URLSearchParams(location.search);
        const utm = ['utm_source', 'utm_medium', 'utm_campaign'].map((k) => q.get(k)).filter(Boolean).join(' / ');
        if (utm) { sessionStorage.setItem('dcSrc', utm); return utm; }
        const saved = sessionStorage.getItem('dcSrc');
        if (saved) return saved;
        const ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.hostname !== location.hostname) { sessionStorage.setItem('dcSrc', ref.hostname); return ref.hostname; }
      } catch (e) { /* ohne Speicher: dann eben ohne Herkunft */ }
      return '';
    })();

    const bind = (sec) => {
      if (sec.__dcQcBound) return;
      sec.__dcQcBound = true;
      const done = sec.querySelector('.dc-qc__done');
      if (done) { sec.classList.add('is-in', 'is-done'); done.focus({ preventScroll: false }); }

      // Einspringen beim ersten Sichtkontakt, Schweben nur solange sichtbar
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => {
          if (e.isIntersecting) sec.classList.add('is-in');
          sec.classList.toggle('is-off', !e.isIntersecting);
        }, { threshold: 0.25 }).observe(sec);
      } else sec.classList.add('is-in');

      sec.querySelectorAll('[data-dc-src]').forEach((el) => { el.value = source || 'direkt'; });

      // Prüfen mit Hinweis am Feld, Fokus auf den ersten Fehler (nur für Formulare der Bühne)
      const form = sec.querySelector('form.dc-qc__form');
      if (!form || !form.querySelector('[name="contact[body]"]')) return;
      form.noValidate = true;
      const fields = [...form.querySelectorAll('[data-err]')];
      let tried = false;
      const check = (el) => {
        const ok = el.checkValidity();
        el.setAttribute('aria-invalid', String(!ok));
        const holder = el.closest('label');
        let msg = holder.nextElementSibling && holder.nextElementSibling.classList.contains('dc-qc__err') ? holder.nextElementSibling : null;
        if (!ok && !msg) { msg = document.createElement('span'); msg.className = 'dc-qc__err'; msg.id = (form.id || 'dc-qc') + '-err-' + fields.indexOf(el); msg.setAttribute('role', 'alert'); msg.textContent = el.dataset.err; holder.after(msg); }
        else if (ok && msg) msg.remove();
        // Hinweis gehört zum Feld: Vorleser lesen ihn beim Fokus mit
        if (!ok) el.setAttribute('aria-describedby', msg.id); else el.removeAttribute('aria-describedby');
        return ok;
      };
      fields.forEach((el) => {
        el.addEventListener('blur', () => { if (el.value || tried) check(el); });
        el.addEventListener('input', () => { if (el.getAttribute('aria-invalid') === 'true') check(el); });
        el.addEventListener('change', () => { if (tried) check(el); });
      });
      // Zeichenzähler am Nachrichtenfeld, falls vorhanden
      const count = form.querySelector('[data-dc-qc-count]');
      const body = form.querySelector('[name="contact[body]"]');
      if (count && body) body.addEventListener('input', () => { count.textContent = body.value.length + ' / ' + (body.maxLength > 0 ? body.maxLength : 1000); });
      form.addEventListener('submit', (e) => {
        tried = true;
        const bad = fields.filter((el) => !check(el));
        if (bad.length) { e.preventDefault(); bad[0].focus(); return; }
        sec.classList.add('is-sending');
        const lab = form.querySelector('[data-dc-qc-send]');
        if (lab) lab.textContent = sec.dataset.labelSending || 'Wird gesendet …';
      });
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-qc]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  (() => {
    if (window.__dcCt) return;
    window.__dcCt = true;

    const fit = (h) => {
      const W = h.clientWidth;
      if (!W) return;
      h.style.fontSize = '';
      h.classList.add('is-fit');
      let fs = parseFloat(getComputedStyle(h).fontSize);
      for (let i = 0; i < 40 && h.scrollWidth > W + 1; i++) { fs *= 0.95; h.style.fontSize = fs.toFixed(2) + 'px'; }
    };

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 900px)');

    // Charakter mit Federphysik: Ziele (Lehnen, Blick zur Maus) und Stöße (Nicken, Hüpfen, Springen).
    // Gerechnet wird pro Bild mit echter Zeit, nur solange die Section sichtbar ist. Nur transform.
    const critter = (sec) => {
      const el = sec.querySelector('[data-dc-ct-char]');
      if (!el || reduce.matches) return null;
      const tag = sec.querySelector('[data-dc-ct-sticker]');
      const st = { r: 0, vr: 0, x: 0, vx: 0, y: 0, vy: 0, tr: 0, tx: 0, ty: 0, lean: 0, look: 0, sr: 0, vsr: 0, t0: performance.now() };
      let raf = 0, last = 0, seen = false;
      const spring = (p, v, target, k, d, dt) => { const a = -k * (p - target) - d * v; v += a * dt; return [p + v * dt, v]; };
      const frame = (now) => {
        raf = 0;
        if (!seen || !wide.matches) { last = 0; return; }
        const dt = Math.min(0.033, last ? (now - last) / 1000 : 0.016);
        last = now;
        const t = (now - st.t0) / 1000;
        // Ziele: lehnt sich beim Tippen zum Formular (links), schaut sonst leicht zur Maus
        // Beim Lehnen zählt der Blick nur halb, damit sich beides nicht aufschaukelt
        const look = st.look * (1 - 0.5 * st.lean);
        st.tr = st.lean * -4 + look * 3;
        st.tx = st.lean * -8 + look * 6;
        [st.r, st.vr] = spring(st.r, st.vr, st.tr, 90, 11, dt);
        [st.x, st.vx] = spring(st.x, st.vx, st.tx, 70, 12, dt);
        [st.y, st.vy] = spring(st.y, st.vy, st.ty, 170, 13, dt);
        [st.sr, st.vsr] = spring(st.sr, st.vsr, st.look * 3 - st.lean * 2, 60, 9, dt);
        // Atmen und leichtes Wiegen: langsam, klein, nie im Gleichtakt
        const breath = Math.sin(t * 1.65) * 0.012;
        const sway = Math.sin(t * 1.13) * 0.9 + Math.sin(t * 0.47) * 0.5;
        // Stauchen und Strecken aus der Geschwindigkeit nach oben oder unten
        const sq = Math.max(-0.09, Math.min(0.09, -st.vy * 0.00016));
        const sy = 1 + breath + sq, sx = 1 - breath * 0.6 - sq * 0.55;
        el.style.transform = 'translate3d(' + st.x.toFixed(2) + 'px,' + st.y.toFixed(2) + 'px,0) rotate(' + (st.r + sway).toFixed(3) + 'deg) scale(' + sx.toFixed(4) + ',' + sy.toFixed(4) + ')';
        if (tag) tag.style.transform = 'translateX(-50%) translate3d(' + (st.x * 0.4).toFixed(2) + 'px,' + (st.y * 0.25).toFixed(2) + 'px,0) rotate(' + (-6 + st.sr + sway * 0.4).toFixed(3) + 'deg)';
        raf = requestAnimationFrame(frame);
      };
      const go = () => { if (!raf) raf = requestAnimationFrame(frame); };
      if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { seen = e.isIntersecting; if (seen) go(); }, { threshold: 0.05 }).observe(sec);
      else { seen = true; go(); }
      wide.addEventListener('change', go);
      // Blick zur Maus: Abstand zur Mitte der Figur, gedämpft
      sec.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const b = el.getBoundingClientRect();
        const dx = (e.clientX - (b.left + b.width / 2)) / Math.max(320, b.width * 1.6);
        st.look = Math.max(-1, Math.min(1, dx));
      }, { passive: true });
      sec.addEventListener('pointerleave', () => { st.look = 0; });
      return {
        lean: (on) => { st.lean = on ? 1 : 0; },
        // Nicken bei jedem Tastendruck: kleiner Stoß, abwechselnd leicht links und rechts
        nod: () => { st.vr += (Math.random() < 0.5 ? -1 : 1) * (8 + Math.random() * 6); st.vy += 55; },
        hop: (k = 1) => { st.vy -= 520 * k; st.vr += (Math.random() - 0.5) * 24; },
        jump: () => { st.vy -= 820; st.vr += 40; setTimeout(() => { st.vy -= 380; st.vr -= 30; }, 520); }
      };
    };

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;
      const title = sec.querySelector('.dc-ct__title');
      if (title) { fit(title); if ('ResizeObserver' in window) new ResizeObserver(() => fit(title)).observe(title); if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fit(title)); }

      const pet = critter(sec);
      const done = sec.querySelector('[data-dc-ct-done]');
      if (done) { sec.classList.add('is-done'); done.focus({ preventScroll: false }); if (pet) setTimeout(() => pet.jump(), 250); return; }

      const form = sec.querySelector('form');
      if (!form) return;
      const body = form.querySelector('[data-dc-ct-body]');

      // Anfrageart wählen: Platzhalter der Nachricht passt sich an. Vorauswahl per Link: ?anfrage=3d-druck usw.
      const kinds = [...form.querySelectorAll('input[name="contact[Anfrageart]"]')];
      kinds.forEach((r) => r.addEventListener('change', () => { if (r.checked && body) body.placeholder = r.dataset.ph || ''; if (pet) pet.hop(); }));
      try {
        const want = (new URLSearchParams(location.search).get('anfrage') || '').toLowerCase().trim();
        const hit = want && (kinds.find((r) => r.dataset.key === want) || kinds.find((r) => r.dataset.key.includes(want) || want.includes(r.dataset.key)));
        if (hit) { hit.checked = true; if (body) body.placeholder = hit.dataset.ph || body.placeholder; }
      } catch (e) { /* ohne URLSearchParams: erste Anfrageart bleibt */ }
      form.addEventListener('input', (e) => { if (pet && e.target.matches('input[type="text"], input[type="email"], textarea')) pet.nod(); });

      // Charakter neigt sich, solange ein Feld den Fokus hat
      form.addEventListener('focusin', () => { sec.classList.add('is-typing'); if (pet) pet.lean(true); });
      form.addEventListener('focusout', (e) => { if (!form.contains(e.relatedTarget)) { sec.classList.remove('is-typing'); if (pet) pet.lean(false); } });

      // Prüfen mit Meldung direkt am Feld
      const check = (el) => {
        const ok = el.type === 'checkbox' ? el.checked : el.checkValidity();
        // Anfrageart: alle Knöpfe der Gruppe gemeinsam markieren
        (el.type === 'radio' ? form.querySelectorAll('input[name="' + el.name + '"]') : [el]).forEach((x) => x.setAttribute('aria-invalid', ok ? 'false' : 'true'));
        const box = el.closest('.dc-ct__field, .dc-ct__privacy, .dc-ct__topics');
        let msg = box && box.parentElement.querySelector(':scope > .dc-ct__msg[data-for="' + el.name + '"]');
        if (!ok && box && !msg) { msg = document.createElement('p'); msg.className = 'dc-ct__msg'; msg.dataset.for = el.name; msg.setAttribute('role', 'alert'); box.after(msg); }
        if (msg) { msg.textContent = ok ? '' : el.dataset.err; msg.hidden = ok; }
        // Hinweis gehört zum Feld: Vorleser lesen ihn beim Fokus mit
        if (msg && !msg.id) msg.id = form.id + '-msg-' + fields.indexOf(el);
        // eigener Hinweis des Feldes (z. B. beim Link) bleibt verknüpft
        const own = el.dataset.desc || '';
        if (!ok && msg) el.setAttribute('aria-describedby', (own + ' ' + msg.id).trim()); else if (own) el.setAttribute('aria-describedby', own); else el.removeAttribute('aria-describedby');
        return ok;
      };
      const fields = [...form.querySelectorAll('[required], input[type="url"]')];
      fields.forEach((el) => { if (el.hasAttribute('aria-describedby')) el.dataset.desc = el.getAttribute('aria-describedby'); });
      fields.forEach((el) => el.addEventListener(el.type === 'checkbox' ? 'change' : 'input', () => { if (el.getAttribute('aria-invalid') === 'true') check(el); }));
      form.addEventListener('submit', (e) => {
        const bad = fields.filter((el) => !check(el));
        if (bad.length) { e.preventDefault(); bad[0].focus(); return; }
        sec.classList.add('is-sending');
        if (pet) pet.hop(1.4);
      });
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-ct]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-folio-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Fester Button am Handy: sichtbar nach dem ersten Bildschirm, weg, sobald der Aufruf selbst im Bild ist
    const bind = (sec) => {
      const btn = sec.querySelector('[data-fcta-float]');
      if (!btn || btn.dataset.bound || !('IntersectionObserver' in window)) return;
      btn.dataset.bound = '1';
      let seen = false;
      const set = () => {
        const on = !seen && window.scrollY > window.innerHeight * 0.9 && sec.getBoundingClientRect().top > window.innerHeight;
        btn.classList.toggle('is-on', on);
        btn.toggleAttribute('aria-hidden', !on);
        btn.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver((es) => { seen = es[0].isIntersecting; set(); }, { threshold: 0 }).observe(sec.querySelector('.dc-fcta__wrap'));
      window.addEventListener('scroll', set, { passive: true });
      set();
    };
    const init = (root = document) => root.querySelectorAll('.dc-fcta').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcIn) return;
    window.__dcIn = true;
    // Überschrift: nie breiter als ihre Spalte, verkleinert bis auch das längste Wort passt
    const fit = (h) => {
      const W = h.clientWidth;
      if (!W) return;
      h.style.fontSize = '';
      h.classList.add('is-fit');
      let fs = parseFloat(getComputedStyle(h).fontSize);
      for (let i = 0; i < 40 && h.scrollWidth > W + 1; i++) { fs *= 0.95; h.style.fontSize = fs.toFixed(2) + 'px'; }
    };
    const ro = 'ResizeObserver' in window ? new ResizeObserver((es) => es.forEach((e) => fit(e.target))) : null;
    const init = (root = document) => root.querySelectorAll('.dc-in__title').forEach((h) => {
      fit(h);
      if (ro) ro.observe(h);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fit(h));
    });
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();

    // „So läuft es ab“: weich auf- und zuklappen (Höhe und Deckkraft des Inhalts), ein Klick während der Bewegung
    // kehrt sie um. Bei „Bewegung reduzieren“ springt es wie gewohnt. Der Inhalt bleibt im HTML (Google liest ihn mit)
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.addEventListener('click', (e) => {
      const sum = e.target.closest && e.target.closest('.dc-in__more > summary');
      if (!sum || reduce.matches || !Element.prototype.animate) return;
      const d = sum.parentElement, body = d.querySelector('.dc-in__body');
      if (!body) return;
      e.preventDefault();
      const opening = !d.open || d.classList.contains('is-closing');
      const from = d.__dcAnim ? body.getBoundingClientRect().height : (d.open ? body.offsetHeight : 0);
      if (d.__dcAnim) d.__dcAnim.cancel();
      d.open = true;
      d.classList.add('is-moving');
      d.classList.toggle('is-closing', !opening);
      const to = opening ? body.scrollHeight : 0;
      const a = body.animate([{ height: from + 'px', opacity: opening ? 0 : 1 }, { height: to + 'px', opacity: opening ? 1 : 0 }], { duration: Math.min(520, 240 + Math.abs(to - from) * 0.35), easing: 'cubic-bezier(.22, 1, .36, 1)' });
      d.__dcAnim = a;
      a.onfinish = () => {
        d.__dcAnim = null;
        d.classList.remove('is-moving', 'is-closing');
        if (!opening) d.open = false;
      };
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-order-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = (sec) => {
      if (sec.__dcOst) return;
      sec.__dcOst = true;
      if (!('IntersectionObserver' in window)) { sec.classList.add('is-seen'); return; }
      new IntersectionObserver(([e]) => sec.classList.toggle('is-seen', e.isIntersecting)).observe(sec);
    };
    const init = (r = document) => r.querySelectorAll('[data-dc-ost]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-pillars"] && !Shopify.designMode) return;
  try {
    
  // Stapel: die verdeckte Karte tritt zurück, sobald die nächste hereinschiebt (Fortschritt 0 bis 1 in --p)
  (() => {
    if (window.__dcStack) return;
    window.__dcStack = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let lists = [];
    let ticking = false;

    const measure = () => {
      ticking = false;
      const vh = window.innerHeight;
      for (const cards of lists) {
        cards.forEach((card, i) => {
          const next = cards[i + 1];
          let p = 0;
          if (next && !reduce.matches) {
            const top = next.getBoundingClientRect().top;
            const end = parseFloat(getComputedStyle(next.parentElement).top) || 0;
            p = Math.min(1, Math.max(0, (vh - top) / Math.max(1, vh - end)));
          }
          const v = (Math.round(p * 100) / 100).toString();
          if (card.style.getPropertyValue('--p') !== v) card.style.setProperty('--p', v);
        });
      }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(measure); } };
    const init = () => {
      lists = [...document.querySelectorAll('[data-dc-stack]')].map((s) => [...s.querySelectorAll('[data-dc-stack-card]')]).filter((l) => l.length > 1);
      measure();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  // Laufband: der Stapel aus Video und Kopien verschiebt sich beim Scrollen um die „Scroll-Weite“ (data-range, px).
  // Gemessen an der natürlichen Lage der Karte im Stapel, auch während sie klebt. Zur Ober- und Unterkante hin wölbt
  // sich jede Kachel leicht weg wie auf einer Trommel (etwas kleiner, gekippt) und tritt zurück (dunkler). Nur, solange sie im Bild ist.
  (() => {
    if (window.__dcDrum) return;
    window.__dcDrum = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const drums = [];
    const visible = new Set();
    let raf = 0;

    const measure = (d) => {
      d.h = d.el.clientHeight;
      d.trackH = d.track.offsetHeight;
      d.mid = d.tiles.map((t) => t.offsetTop + t.offsetHeight / 2);
      // Natürliche Lage der Karte: Oberkante der Liste plus Höhen der Karten davor (die Liste selbst klebt nicht)
      const list = d.item.parentElement;
      const items = [...list.children];
      const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
      let top = 0;
      for (const it of items) { if (it === d.item) break; top += it.offsetHeight + gap; }
      d.listTop = list.getBoundingClientRect().top + window.scrollY;
      d.top = top;
      d.itemH = d.item.offsetHeight;
    };

    const paint = (d) => {
      const vh = window.innerHeight;
      const center = d.listTop + d.top + d.itemH / 2;
      const p = Math.max(-1.25, Math.min(1.25, (window.scrollY + vh / 2 - center) / vh));
      const shift = -p * d.range;
      d.track.style.transform = 'translate3d(0, calc(-50% + ' + shift.toFixed(1) + 'px), 0)';
      const top = d.h / 2 - d.trackH / 2 + shift;
      d.tiles.forEach((t, i) => {
        const k = Math.max(-1.6, Math.min(1.6, ((top + d.mid[i]) / (d.h || 1) - 0.5) * 2));
        const s = 1 - 0.07 * k * k;
        t.style.transform = 'perspective(1200px) rotateX(' + (-k * 10).toFixed(2) + 'deg) scale(' + s.toFixed(3) + ')';
        t.style.setProperty('--dim', Math.min(0.35, 0.18 * k * k).toFixed(3));
      });
    };

    const tick = () => { raf = 0; visible.forEach(paint); };
    const kick = () => { if (!raf && visible.size) raf = requestAnimationFrame(tick); };

    const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
      es.forEach((e) => { const d = e.target.__drum; if (!d) return; if (e.isIntersecting) { measure(d); visible.add(d); } else visible.delete(d); });
      kick();
    }, { rootMargin: '15% 0px' }) : null;

    const bind = (el) => {
      if (el.__drum || reduce.matches) return;
      const item = el.closest('.dc-stack__item');
      const track = el.querySelector('[data-drum-track]');
      if (!item || !track) return;
      const d = { el, item, track, tiles: [...track.querySelectorAll('[data-drum-tile]')], range: parseFloat(el.dataset.range) || 0 };
      el.__drum = d;
      drums.push(d);
      measure(d);
      paint(d);
      if (io) io.observe(el); else visible.add(d);
      if ('ResizeObserver' in window) new ResizeObserver(() => { measure(d); paint(d); }).observe(el);
    };

    const init = (scope = document) => scope.querySelectorAll('[data-dc-drum]').forEach(bind);
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', () => { drums.forEach(measure); kick(); }, { passive: true });
    window.addEventListener('load', () => { drums.forEach(measure); kick(); });
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-portfolio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcPf) return;
    window.__dcPf = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const stacked = window.matchMedia('(max-width: 999px)');
    const small = window.matchMedia('(max-width: 899px)');
    const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    // Das große Wort füllt die Breite der Kachel genau
    const fitWord = (el) => {
      const box = el.parentElement;
      const W = box.clientWidth - parseFloat(getComputedStyle(box).paddingLeft) - parseFloat(getComputedStyle(box).paddingRight);
      if (!W) return;
      el.style.fontSize = '100px';
      const w = el.scrollWidth || 1;
      el.style.fontSize = Math.min(W * 0.6, (100 * W) / w * 0.99).toFixed(2) + 'px';
    };

    // Unter den Header scrollen; läuft das weiche Scrollen des Themes, über dieses
    const scrollToEl = (el) => {
      const root = document.documentElement;
      const head = parseFloat(getComputedStyle(root).getPropertyValue('--sticky-area-height')) || (document.querySelector('.shopify-section--header') || {}).offsetHeight || 0;
      const y = Math.max(0, el.getBoundingClientRect().top + scrollY - head - 16);
      if (reduce.matches) { window.scrollTo(0, y); return; }
      if (window.dcSmooth && window.dcSmooth.enabled()) window.dcSmooth.go(y);
      else window.scrollTo({ top: y, behavior: 'smooth' });
    };

    // Handy: vor dem ersten Abspielen die kleinere Datei (HLS oder bis 720 px)
    const prep = (v) => {
      if (v.dataset.dcPrepared) return;
      v.dataset.dcPrepared = '1';
      const s = v.querySelector('source');
      if (!s || !small.matches) return;
      if (v.dataset.srcHls && v.canPlayType('application/vnd.apple.mpegurl')) { s.src = v.dataset.srcHls; s.type = 'application/vnd.apple.mpegurl'; v.load(); }
      else if (v.dataset.srcSm) { s.src = v.dataset.srcSm; v.load(); }
    };

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;

      // ---------- Einstieg: Wort, Namen der Artists, Schweben mit Pause-Taste ----------
      const word = sec.querySelector('[data-dc-pf-word]');
      if (word) {
        fitWord(word);
        if ('ResizeObserver' in window) new ResizeObserver(() => fitWord(word)).observe(word.parentElement);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fitWord(word));
      }
      const names = [...sec.querySelectorAll('.dc-pf-artist__name')];
      // Lange Namen: Schrift so weit verkleinern, dass das längste Wort in die Karte passt (auch nach Größenänderung)
      const fitName = (n) => {
        n.style.fontSize = '';
        n.classList.add('is-fit');
        const W = n.clientWidth;
        if (!W) return;
        let fs = parseFloat(getComputedStyle(n).fontSize);
        for (let i = 0; i < 30 && n.scrollWidth > W + 1; i++) { fs *= 0.94; n.style.fontSize = fs.toFixed(2) + 'px'; }
      };
      const fitNames = () => names.forEach(fitName);
      fitNames();
      if ('ResizeObserver' in window && names.length) new ResizeObserver(fitNames).observe(names[0].closest('.dc-pf__artists'));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNames);

      const st = { artist: null, cat: '', cur: -1, paused: false, introVisible: false };
      const sync = () => {
        sec.classList.toggle('is-live', st.introVisible && !document.hidden);
        sec.classList.toggle('is-paused', st.paused);
      };
      const btn = sec.querySelector('[data-dc-pf-pause]');
      const intro = sec.querySelector('.dc-pf__intro');
      if (intro && 'IntersectionObserver' in window) new IntersectionObserver(([e]) => { st.introVisible = e.isIntersecting; sync(); }, { threshold: 0.02 }).observe(intro);
      else { st.introVisible = true; sync(); }


      // ---------- Arbeiten: Liste und Bühne ----------
      const gate = sec.querySelector('[data-dc-pf-gate]');
      const wv = sec.querySelector('[data-dc-wv]');
      if (!wv) return;
      const picks = [...sec.querySelectorAll('[data-dc-pf-pick]')];
      const profiles = [...sec.querySelectorAll('[data-dc-pf-profile]')];
      const artistsWrap = sec.querySelector('.dc-pf__artists');
      const artistsBlock = artistsWrap ? artistsWrap.closest('.dc-pf__block') : null;
      const title = wv.querySelector('[data-dc-wv-title]');
      const allTitle = title ? title.innerHTML : '';
      const rows = [...wv.querySelectorAll('.dc-wv-row')];
      const slides = [...wv.querySelectorAll('.dc-wv-slide')];
      const chips = [...wv.querySelectorAll('[data-dc-wv-cat]')];
      const chipRow = wv.querySelector('.dc-wv__chips');
      const status = wv.querySelector('[data-dc-wv-status]');
      const empty = wv.querySelector('[data-dc-wv-empty]');
      const voices = [...wv.querySelectorAll('.dc-wv-voice')];
      const stage = wv.querySelector('[data-dc-wv-stage]');
      const change = wv.querySelector('[data-dc-wv-change]');
      const videos = slides.map((s) => [...s.querySelectorAll('video')]);
      videos.flat().forEach((v) => { v.muted = true; v.defaultMuted = true; v.playsInline = true; });
      st.visible = false;

      const gated = () => sec.classList.contains('is-gated');
      // Videos: alle Werke des gezeigten Projekts laufen, die anderen stehen
      const play = () => {
        const ok = st.visible && !st.paused && !document.hidden && !gated() && !reduce.matches;
        videos.forEach((list, i) => list.forEach((v) => {
          if (ok && i === st.cur) { prep(v); if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); }
          else v.pause();
        }));
      };

      // Nachbarn (der sichtbaren Projekte) laden vor, damit der Wechsel sofort ein Bild hat
      const near = (i) => {
        const vis = rows.map((r, j) => (r.classList.contains('is-hide') ? -1 : j)).filter((j) => j >= 0);
        const p = vis.indexOf(i);
        const keep = new Set([vis[p - 1], vis[p + 1]]);
        slides.forEach((s, j) => s.classList.toggle('is-near', keep.has(j) && j !== i));
      };

      // Projekt zeigen: das alte blendet schnell aus, das neue ein (abbrechbar)
      const activate = (i) => {
        if (i < 0 || i === st.cur) return;
        const prev = slides[st.cur];
        const next = slides[i];
        rows.forEach((r, j) => r.classList.toggle('is-on', j === i));
        if (prev) {
          prev.classList.remove('is-on');
          prev.classList.add('is-out');
          clearTimeout(prev.__t);
          prev.__t = setTimeout(() => prev.classList.remove('is-out'), 160);
        }
        clearTimeout(next.__t);
        next.classList.remove('is-out', 'is-near');
        next.classList.add('is-on');
        st.cur = i;
        near(i);
        play();
      };

      // Am Computer: Zeigen wechselt sofort, Tastatur-Fokus auch. Klick öffnet das Projekt. Scrollen wechselt nichts
      rows.forEach((r, i) => {
        const a = r.querySelector('[data-dc-wv-row]');
        if (!a) return;
        a.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') activate(i); });
        a.addEventListener('focus', () => activate(i));
        if (a.tagName !== 'A') a.addEventListener('click', () => activate(i));
      });
      if (stage) stage.addEventListener('click', (e) => {
        if (stacked.matches || e.target.closest('a')) return;
        const s = e.target.closest('.dc-wv-slide');
        const h = s && s.dataset.href;
        if (h) window.location.href = h;
      });

      // Filter: Artist (oben) und eine Leistung. Nicht passende Projekte verschwinden ganz.
      // Leistungen, die der gewählte Artist nicht hat, werden nicht angeboten.
      const has = (el, key, val) => (el.dataset[key] || ' ').includes(' ' + val + ' ');
      const apply = () => {
        chips.forEach((c) => {
          const k = c.dataset.dcWvCat;
          if (!k) return;
          c.hidden = !rows.some((r) => (!st.artist || has(r, 'artists', st.artist)) && has(r, 'cats', k));
          if (c.hidden && st.cat === k) st.cat = '';
        });
        chips.forEach((c) => c.setAttribute('aria-pressed', String((c.dataset.dcWvCat || '') === st.cat)));
        if (chipRow) chipRow.hidden = chips.filter((c) => c.dataset.dcWvCat && !c.hidden).length < 2;
        let n = 0;
        rows.forEach((r, i) => {
          const on = (!st.artist || has(r, 'artists', st.artist)) && (!st.cat || has(r, 'cats', st.cat));
          r.classList.toggle('is-hide', !on);
          slides[i].classList.toggle('is-hide', !on);
          if (on) n++;
        });
        voices.forEach((v) => v.classList.toggle('is-hide', !!st.artist && !has(v, 'artists', st.artist)));
        if (status) status.textContent = n + ' ' + (status.dataset.label || '');
        if (empty) empty.hidden = n > 0;
        wv.classList.toggle('is-empty', n === 0);
        if (st.cur < 0 || rows[st.cur].classList.contains('is-hide')) {
          const prev = st.cur;
          st.cur = -1;
          if (slides[prev]) slides[prev].classList.remove('is-on');
          activate(rows.findIndex((r) => !r.classList.contains('is-hide')));
        } else near(st.cur);
      };
      // Immer nur eine Leistung: Klick wählt sie, Klick auf die gewählte oder „Alles“ zeigt wieder alles
      chips.forEach((c) => c.addEventListener('click', () => {
        const k = c.dataset.dcWvCat || '';
        st.cat = k && k !== st.cat ? k : '';
        apply();
      }));

      // Artist wählen: Karte wird blau mit „Ausgewählt“, die Arbeiten klappen darunter auf. Die Seite springt nicht.
      const choose = (h) => {
        st.artist = h;
        st.cat = '';
        picks.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.dcPfPick === h)));
        if (artistsWrap) artistsWrap.classList.add('has-pick');
        profiles.forEach((p) => { p.hidden = p.dataset.dcPfProfile !== h; });
        const pk = picks.find((p) => p.dataset.dcPfPick === h);
        if (title) title.innerHTML = h && pk ? esc(title.dataset.for) + ' <em>' + esc(pk.dataset.name) + '</em>' : allTitle;
        if (gate && gated()) {
          gate.classList.add('is-opening');
          sec.classList.remove('is-gated');
          gate.inert = false;
          setTimeout(() => gate.classList.remove('is-opening'), 750);
        }
        apply();
        play();
        try { history.replaceState(null, '', location.pathname + location.search + '#' + (h ? 'artist-' + h : 'alle')); } catch (e) { /* Adresse bleibt */ }
      };
      picks.forEach((p) => p.addEventListener('click', () => choose(p.dataset.dcPfPick)));
      if (change && artistsBlock) change.addEventListener('click', () => scrollToEl(artistsBlock));

      // Sichtbarkeit: Computer über die Bühne, Handy über das Projekt, das gerade am meisten im Bild ist
      const ratios = new Map();
      if ('IntersectionObserver' in window) {
        if (stage) new IntersectionObserver(([e]) => { if (stacked.matches) return; st.visible = e.isIntersecting; play(); }, { threshold: 0.15 }).observe(stage);
        const sio = new IntersectionObserver((es) => {
          es.forEach((e) => ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0));
          if (!stacked.matches) return;
          let best = -1;
          let br = 0.4;
          slides.forEach((s, i) => { const r = ratios.get(s) || 0; if (r > br) { br = r; best = i; } });
          st.visible = best >= 0;
          if (best >= 0 && best !== st.cur) activate(best);
          else play();
        }, { threshold: [0, 0.4, 0.6, 0.85] });
        slides.forEach((s) => sio.observe(s));
      } else st.visible = true;

      if (btn) btn.addEventListener('click', () => {
        st.paused = !st.paused;
        btn.setAttribute('aria-pressed', String(st.paused));
        btn.setAttribute('aria-label', st.paused ? 'Bewegung starten' : 'Bewegung anhalten');
        sync();
        play();
      });
      document.addEventListener('visibilitychange', () => { sync(); play(); });

      // Start: Link mit #artist-…, #alle oder #kategorie-… öffnet direkt. Sonst erst einen Artist wählen.
      const hash = decodeURIComponent(location.hash.slice(1)).split('&');
      let start = null;
      hash.forEach((part) => {
        const a = part.match(/^artist-(.+)$/);
        if (a && picks.some((p) => p.dataset.dcPfPick === a[1])) start = a[1];
        if (part === 'alle') start = '';
      });
      const cat = hash.map((p) => (p.match(/^kategorie-(.+)$/) || [])[1]).find((k) => k && chips.some((c) => c.dataset.dcWvCat === k));
      if (cat && start === null) start = '';
      if (!picks.length && start === null) start = '';
      if (start === null && gate) {
        sec.classList.add('is-gated');
        gate.inert = true;
        apply();
      } else {
        choose(start || '');
        if (cat) { st.cat = cat; apply(); }
      }
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-pf]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-price-calc"] && !Shopify.designMode) return;
  try {
    
  // Preisrechner 3D-Druck: Richtpreis aus Druckpauschale und Stunden fürs Modellieren
  (() => {
    if (window.__dcCalc) return;
    window.__dcCalc = true;
    const bind = (sec) => {
      if (sec.__calc) return;
      sec.__calc = true;
      const d = sec.dataset;
      const print = Number(d.print) || 0;
      const rate = Number(d.rate) || 0;
      const hours = { 1: Number(d.h1) || 1, 2: Number(d.h2) || 2 };
      const model = sec.querySelector('[data-calc-model]');
      const price = sec.querySelector('[data-calc-price]');
      const line = sec.querySelector('[data-calc-line]');
      const btn = sec.querySelector('[data-calc-btn]');
      const eur = (n) => d.tEur.replace('#p', n);
      model.hidden = true;
      const update = () => {
        const f = sec.querySelector('[data-calc-file]:checked');
        const l = sec.querySelector('[data-calc-level]:checked');
        if (!f) return;
        const hasFile = f.value === 'ja';
        model.hidden = hasFile;
        if (btn) btn.href = '/pages/kontakt?anfrage=3d-druck' + (hasFile ? '&produkt=datei-drucken' : '');
        if (hasFile) { price.textContent = eur(print); line.textContent = d.tFile; return; }
        if (!l || l.value === '0') {
          price.textContent = d.tRange.replace('#lo', print + hours[1] * rate).replace('#hi', print + hours[2] * rate);
          line.textContent = d.tUnsure;
          return;
        }
        const h = hours[l.value];
        price.textContent = eur(print + h * rate);
        line.textContent = d.tModel.replace('#h', h);
      };
      sec.addEventListener('change', update);
      update();
    };
    const init = (scope = document) => scope.querySelectorAll('[data-dc-calc]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcPd) return;
    window.__dcPd = true;

    // Geld wie im Shop formatiert (shop.money_format)
    const money = (cents, fmt) => {
      const n = (cents / 100);
      const parts = (d, ts, ds) => { const [i, f] = n.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : ''); };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
        amount: parts(2, ',', '.'), amount_no_decimals: parts(0, ',', '.'),
        amount_with_comma_separator: parts(2, '.', ','), amount_no_decimals_with_comma_separator: parts(0, '.', ','),
        amount_with_apostrophe_separator: parts(2, "'", '.'), amount_with_space_separator: parts(2, ' ', ',')
      }[k] || parts(2, '.', ',')));
    };

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;
      const data = JSON.parse(sec.querySelector('[data-dc-pd-json]').textContent);
      const stage = sec.querySelector('[data-dc-pd-stage]');
      const slides = [...sec.querySelectorAll('.dc-pd__slide')];
      const thumbs = [...sec.querySelectorAll('[data-dc-pd-thumb]')];
      const small = window.matchMedia('(max-width: 699px)');

      // Bild zeigen: Computer blendet, Handy wischt dorthin
      const show = (id, scroll) => {
        const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(id));
        if (i < 0) return;
        slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); const v = s.querySelector('video'); if (v && k !== i) v.pause(); });
        thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.dcPdThumb === String(id))));
        if (small.matches && scroll) stage.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      };
      thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.dcPdThumb, true)));
      stage.addEventListener('keydown', (e) => {
        const cur = slides.findIndex((s) => s.classList.contains('is-active'));
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const n = (cur + (e.key === 'ArrowRight' ? 1 : -1) + slides.length) % slides.length; show(slides[n].dataset.mediaId, true); }
      });
      // Handy: Punkte folgen dem Wischen
      let tick = false;
      stage.addEventListener('scroll', () => {
        if (!small.matches || tick) return;
        tick = true;
        requestAnimationFrame(() => {
          tick = false;
          const i = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
          if (slides[i]) thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.dcPdThumb === String(slides[i].dataset.mediaId))));
        });
      }, { passive: true });

      // Varianten: Pillen bestimmen die Variante, Preis, Button und Bild folgen
      const form = sec.querySelector('form.dc-pd__form');
      if (!form) return;
      const idInput = form.querySelector('[data-dc-pd-id]');
      const radios = [...form.querySelectorAll('[data-dc-pd-option]')];
      const add = form.querySelector('[data-dc-pd-add]');
      const addLabel = form.querySelector('[data-dc-pd-addlabel]');
      const now = sec.querySelector('[data-dc-pd-now]');
      const was = sec.querySelector('[data-dc-pd-was]');
      const selected = () => { const o = []; radios.forEach((r) => { if (r.checked) o[Number(r.dataset.dcPdOption)] = r.value; }); return o; };
      const mark = () => {
        // Werte durchstreichen, die mit der aktuellen Auswahl nicht lieferbar sind
        const sel = selected();
        radios.forEach((r) => {
          const pos = Number(r.dataset.dcPdOption);
          const test = sel.slice(); test[pos] = r.value;
          const ok = data.variants.some((v) => v.available && v.options.every((x, i) => x === test[i]));
          r.closest('.dc-pd__pill').classList.toggle('is-off', !ok);
        });
      };
      const update = () => {
        const sel = selected();
        const v = data.variants.find((x) => x.options.every((o, i) => o === sel[i]));
        sel.forEach((val, i) => { const b = sec.querySelector('[data-dc-pd-optval="' + i + '"]'); if (b) b.textContent = val; });
        mark();
        if (!v) { add.disabled = true; addLabel.textContent = data.labels.none; return; }
        idInput.value = v.id;
        add.disabled = !v.available;
        addLabel.textContent = v.available ? data.labels.add : data.labels.sold;
        now.textContent = money(v.price, data.moneyFormat);
        if (v.compare_at_price > v.price) { was.hidden = false; was.textContent = money(v.compare_at_price, data.moneyFormat); } else was.hidden = true;
        if (v.featured_media) show(v.featured_media.id, true);
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      };
      radios.forEach((r) => r.addEventListener('change', update));
      if (radios.length) mark();

      // Menge
      const q = form.querySelector('[name="quantity"]');
      form.querySelectorAll('[data-dc-pd-q]').forEach((b) => b.addEventListener('click', () => { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.dcPdQ)); }));
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-pd]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-quick-contact"] && !Shopify.designMode) return;
  try {
    
  /* Gemeinsame Anfrage-Bühne (dc-quick-contact, dc-request, dc-contact): Formen springen ein und schweben, Pause-Taste,
     Prüfen am Feld, Sende-Zustand und Herkunft der Anfrage. Steht gleich in allen drei Sections, weil Shopify das Skript
     einer Section nur auf Seiten lädt, auf denen sie vorkommt. Läuft nur einmal pro Seite. */
  (() => {
    if (window.__dcQc2) return;
    window.__dcQc2 = true;

    // Herkunft: Kampagne aus dem Link (utm_*), sonst die fremde Seite, von der man kam. Bleibt für den Besuch gespeichert
    // (sessionStorage, nur diese drei Werte, nichts Persönliches), damit sie auch auf einer späteren Seite mitgeht.
    const source = (() => {
      try {
        const q = new URLSearchParams(location.search);
        const utm = ['utm_source', 'utm_medium', 'utm_campaign'].map((k) => q.get(k)).filter(Boolean).join(' / ');
        if (utm) { sessionStorage.setItem('dcSrc', utm); return utm; }
        const saved = sessionStorage.getItem('dcSrc');
        if (saved) return saved;
        const ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.hostname !== location.hostname) { sessionStorage.setItem('dcSrc', ref.hostname); return ref.hostname; }
      } catch (e) { /* ohne Speicher: dann eben ohne Herkunft */ }
      return '';
    })();

    const bind = (sec) => {
      if (sec.__dcQcBound) return;
      sec.__dcQcBound = true;
      const done = sec.querySelector('.dc-qc__done');
      if (done) { sec.classList.add('is-in', 'is-done'); done.focus({ preventScroll: false }); }

      // Einspringen beim ersten Sichtkontakt, Schweben nur solange sichtbar
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => {
          if (e.isIntersecting) sec.classList.add('is-in');
          sec.classList.toggle('is-off', !e.isIntersecting);
        }, { threshold: 0.25 }).observe(sec);
      } else sec.classList.add('is-in');

      sec.querySelectorAll('[data-dc-src]').forEach((el) => { el.value = source || 'direkt'; });

      // Prüfen mit Hinweis am Feld, Fokus auf den ersten Fehler (nur für Formulare der Bühne)
      const form = sec.querySelector('form.dc-qc__form');
      if (!form || !form.querySelector('[name="contact[body]"]')) return;
      form.noValidate = true;
      const fields = [...form.querySelectorAll('[data-err]')];
      let tried = false;
      const check = (el) => {
        const ok = el.checkValidity();
        el.setAttribute('aria-invalid', String(!ok));
        const holder = el.closest('label');
        let msg = holder.nextElementSibling && holder.nextElementSibling.classList.contains('dc-qc__err') ? holder.nextElementSibling : null;
        if (!ok && !msg) { msg = document.createElement('span'); msg.className = 'dc-qc__err'; msg.id = (form.id || 'dc-qc') + '-err-' + fields.indexOf(el); msg.setAttribute('role', 'alert'); msg.textContent = el.dataset.err; holder.after(msg); }
        else if (ok && msg) msg.remove();
        // Hinweis gehört zum Feld: Vorleser lesen ihn beim Fokus mit
        if (!ok) el.setAttribute('aria-describedby', msg.id); else el.removeAttribute('aria-describedby');
        return ok;
      };
      fields.forEach((el) => {
        el.addEventListener('blur', () => { if (el.value || tried) check(el); });
        el.addEventListener('input', () => { if (el.getAttribute('aria-invalid') === 'true') check(el); });
        el.addEventListener('change', () => { if (tried) check(el); });
      });
      // Zeichenzähler am Nachrichtenfeld, falls vorhanden
      const count = form.querySelector('[data-dc-qc-count]');
      const body = form.querySelector('[name="contact[body]"]');
      if (count && body) body.addEventListener('input', () => { count.textContent = body.value.length + ' / ' + (body.maxLength > 0 ? body.maxLength : 1000); });
      form.addEventListener('submit', (e) => {
        tried = true;
        const bad = fields.filter((el) => !check(el));
        if (bad.length) { e.preventDefault(); bad[0].focus(); return; }
        sec.classList.add('is-sending');
        const lab = form.querySelector('[data-dc-qc-send]');
        if (lab) lab.textContent = sec.dataset.labelSending || 'Wird gesendet …';
      });
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-qc]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-request"] && !Shopify.designMode) return;
  try {
    
  /* Gemeinsame Anfrage-Bühne (dc-quick-contact, dc-request, dc-contact): Formen springen ein und schweben, Pause-Taste,
     Prüfen am Feld, Sende-Zustand und Herkunft der Anfrage. Steht gleich in allen drei Sections, weil Shopify das Skript
     einer Section nur auf Seiten lädt, auf denen sie vorkommt. Läuft nur einmal pro Seite. */
  (() => {
    if (window.__dcQc2) return;
    window.__dcQc2 = true;

    // Herkunft: Kampagne aus dem Link (utm_*), sonst die fremde Seite, von der man kam. Bleibt für den Besuch gespeichert
    // (sessionStorage, nur diese drei Werte, nichts Persönliches), damit sie auch auf einer späteren Seite mitgeht.
    const source = (() => {
      try {
        const q = new URLSearchParams(location.search);
        const utm = ['utm_source', 'utm_medium', 'utm_campaign'].map((k) => q.get(k)).filter(Boolean).join(' / ');
        if (utm) { sessionStorage.setItem('dcSrc', utm); return utm; }
        const saved = sessionStorage.getItem('dcSrc');
        if (saved) return saved;
        const ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.hostname !== location.hostname) { sessionStorage.setItem('dcSrc', ref.hostname); return ref.hostname; }
      } catch (e) { /* ohne Speicher: dann eben ohne Herkunft */ }
      return '';
    })();

    const bind = (sec) => {
      if (sec.__dcQcBound) return;
      sec.__dcQcBound = true;
      const done = sec.querySelector('.dc-qc__done');
      if (done) { sec.classList.add('is-in', 'is-done'); done.focus({ preventScroll: false }); }

      // Einspringen beim ersten Sichtkontakt, Schweben nur solange sichtbar
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => {
          if (e.isIntersecting) sec.classList.add('is-in');
          sec.classList.toggle('is-off', !e.isIntersecting);
        }, { threshold: 0.25 }).observe(sec);
      } else sec.classList.add('is-in');

      sec.querySelectorAll('[data-dc-src]').forEach((el) => { el.value = source || 'direkt'; });

      // Prüfen mit Hinweis am Feld, Fokus auf den ersten Fehler (nur für Formulare der Bühne)
      const form = sec.querySelector('form.dc-qc__form');
      if (!form || !form.querySelector('[name="contact[body]"]')) return;
      form.noValidate = true;
      const fields = [...form.querySelectorAll('[data-err]')];
      let tried = false;
      const check = (el) => {
        const ok = el.checkValidity();
        el.setAttribute('aria-invalid', String(!ok));
        const holder = el.closest('label');
        let msg = holder.nextElementSibling && holder.nextElementSibling.classList.contains('dc-qc__err') ? holder.nextElementSibling : null;
        if (!ok && !msg) { msg = document.createElement('span'); msg.className = 'dc-qc__err'; msg.id = (form.id || 'dc-qc') + '-err-' + fields.indexOf(el); msg.setAttribute('role', 'alert'); msg.textContent = el.dataset.err; holder.after(msg); }
        else if (ok && msg) msg.remove();
        // Hinweis gehört zum Feld: Vorleser lesen ihn beim Fokus mit
        if (!ok) el.setAttribute('aria-describedby', msg.id); else el.removeAttribute('aria-describedby');
        return ok;
      };
      fields.forEach((el) => {
        el.addEventListener('blur', () => { if (el.value || tried) check(el); });
        el.addEventListener('input', () => { if (el.getAttribute('aria-invalid') === 'true') check(el); });
        el.addEventListener('change', () => { if (tried) check(el); });
      });
      // Zeichenzähler am Nachrichtenfeld, falls vorhanden
      const count = form.querySelector('[data-dc-qc-count]');
      const body = form.querySelector('[name="contact[body]"]');
      if (count && body) body.addEventListener('input', () => { count.textContent = body.value.length + ' / ' + (body.maxLength > 0 ? body.maxLength : 1000); });
      form.addEventListener('submit', (e) => {
        tried = true;
        const bad = fields.filter((el) => !check(el));
        if (bad.length) { e.preventDefault(); bad[0].focus(); return; }
        sec.classList.add('is-sending');
        const lab = form.querySelector('[data-dc-qc-send]');
        if (lab) lab.textContent = sec.dataset.labelSending || 'Wird gesendet …';
      });
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-qc]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-selected"] && !Shopify.designMode) return;
  try {
    
  // Ausgewählte Arbeiten: Wechsel, Videos, Pause. Der Strich der aktiven Arbeit füllt sich (CSS) und meldet sein Ende.
  (() => {
    if (window.__dcSel) return;
    window.__dcSel = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const narrow = window.matchMedia('(max-width: 899px)');

    const load = (v) => {
      if (!v || v.dataset.loaded) return;
      v.dataset.loaded = '1';
      const hls = v.dataset.srcHls;
      const sm = narrow.matches && v.dataset.srcSm;
      v.src = narrow.matches && hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : (sm || v.dataset.src);
      // Fehlt die 720p-Fassung, auf die Originalquelle zurück
      if (sm) v.addEventListener('error', () => { if (v.src.includes('720p')) { v.src = v.dataset.src; const p = v.play(); if (p && p.catch) p.catch(() => {}); } }, { once: true });
    };
    const play = (v) => { if (!v) return; load(v); v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); };

    const bind = (sec) => {
      if (sec.__sel) return;
      sec.__sel = true;
      const slides = [...sec.querySelectorAll('[data-sel-slide]')];
      const segs = [...sec.querySelectorAll('[data-sel-seg]')];
      // Bühne führt zur Projektseite der gezeigten Arbeit (ohne Skript: ins Portfolio)
      const frame = sec.querySelector('[data-sel-frame]');
      if (frame && slides[0] && slides[0].dataset.href) frame.href = slides[0].dataset.href;
      const pause = sec.querySelector('[data-sel-pause]');
      let cur = 0;
      let live = false;
      const vid = (i) => slides[i] && slides[i].querySelector('video');

      // Während des Wechsels laufen beide Videos: das alte, bis es ganz verdeckt ist, das neue schon vor dem Aufdecken
      let keep = -1;
      const syncVideo = () => {
        slides.forEach((s, i) => {
          const v = vid(i);
          if (!v) return;
          if ((i === cur || i === keep) && live && !reduce.matches) play(v); else if (!v.paused) v.pause();
        });
      };
      // Das nächste Video schon puffern, solange das aktuelle läuft
      const warmNext = () => {
        const nx = vid((cur + 1) % slides.length);
        if (nx && !reduce.matches) { nx.preload = 'auto'; load(nx); }
      };
      const ready = (v) => new Promise((done) => {
        if (!v || reduce.matches) return done();
        play(v);
        if (v.readyState >= 3 && !v.paused) return done();
        const t = setTimeout(done, 900);
        v.addEventListener('playing', () => { clearTimeout(t); done(); }, { once: true });
      });

      let busy = false;
      const show = async (n) => {
        if (n === cur || !slides[n] || busy) return;
        busy = true;
        const old = cur;
        keep = old;
        await ready(live ? vid(n) : null);
        const prev = slides[old];
        prev.classList.remove('is-active');
        prev.classList.add('is-prev');
        slides[n].classList.add('is-active');
        if (frame && slides[n].dataset.href) frame.href = slides[n].dataset.href;
        segs.forEach((s, i) => {
          s.classList.toggle('is-on', i === n);
          if (i === n) s.setAttribute('aria-current', 'true'); else s.removeAttribute('aria-current');
        });
        // Strich neu starten
        const fill = segs[n] && segs[n].querySelector('i');
        if (fill) { fill.style.display = 'none'; void fill.offsetWidth; fill.style.display = ''; }
        cur = n;
        syncVideo();
        setTimeout(() => {
          prev.classList.remove('is-prev');
          keep = -1;
          syncVideo();
          warmNext();
          busy = false;
        }, reduce.matches ? 0 : 1500);
      };

      segs.forEach((s, i) => {
        s.addEventListener('click', () => show(i));
        s.querySelector('i').addEventListener('animationend', () => {
          if (s.classList.contains('is-on') && slides.length > 1) show((cur + 1) % slides.length);
        });
      });
      if (pause) pause.addEventListener('click', () => {
        const on = pause.getAttribute('aria-pressed') !== 'true';
        pause.setAttribute('aria-pressed', String(on));
        pause.setAttribute('aria-label', on ? pause.dataset.labelPlay : pause.dataset.labelPause);
        sec.classList.toggle('is-paused', on);
      });

      if (slides.length > 1 && !reduce.matches) sec.classList.add('is-auto');
      requestAnimationFrame(() => sec.classList.add('is-ready'));
      // Vorladen, sobald die Section bis zu zwei Bildschirme entfernt ist, aber erst nach der ersten Bedienung der Seite
      // (dc-studio.js setzt data-dc-engaged; seit Paket 15). Ist die Section beim Laden schon im Bild, sofort.
      let isNear = false, warmed = false;
      const warmUp = () => { if (warmed) return; warmed = true; const v = vid(cur); if (v) { v.preload = 'auto'; load(v); } warmNext(); if (near) near.disconnect(); };
      const engaged = () => document.documentElement.dataset.dcEngaged === '1';
      const near = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
        isNear = es.some((e) => e.isIntersecting);
        if (!isNear || reduce.matches) return;
        const r = sec.getBoundingClientRect();
        if (engaged() || (r.top < innerHeight && r.bottom > 0)) warmUp();
      }, { rootMargin: '200% 0px' }) : null;
      if (near) near.observe(sec);
      document.addEventListener('dc:engaged', () => { if (isNear && !reduce.matches) warmUp(); }, { once: true });
      const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
        es.forEach((e) => { live = e.isIntersecting && !document.hidden; sec.classList.toggle('is-live', live); syncVideo(); });
      }, { threshold: 0.25 }) : null;
      if (io) io.observe(sec); else { live = true; sec.classList.add('is-live'); syncVideo(); }
      document.addEventListener('visibilitychange', () => { live = live && !document.hidden; sec.classList.toggle('is-live', live); syncVideo(); });
    };

    const init = (scope = document) => scope.querySelectorAll('[data-dc-sel]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      const sec = e.target.closest('[data-dc-sel]');
      if (sec) { const i = [...sec.querySelectorAll('[data-sel-slide]')].indexOf(e.target); const seg = sec.querySelectorAll('[data-sel-seg]')[i]; if (seg) seg.click(); }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-services"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcSvc) return;
    window.__dcSvc = true;
    const narrow = window.matchMedia('(max-width: 899px)');

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;
      const rows = [...sec.querySelectorAll('[data-dc-svc-row]')];
      const scenes = [...sec.querySelectorAll('[data-dc-svc-scene]')];
      const open = (i) => {
        rows.forEach((r, k) => {
          const on = k === i;
          r.classList.toggle('is-open', on);
          r.querySelector('button').setAttribute('aria-expanded', String(on));
        });
        scenes.forEach((s, k) => { const on = k === Math.max(0, i); s.classList.toggle('is-on', on); s.inert = !on; });
      };
      rows.forEach((r, i) => r.querySelector('button').addEventListener('click', () => {
        // Am Computer bleibt immer eine Leistung offen, auf dem Handy lässt sie sich schließen
        open(r.classList.contains('is-open') && narrow.matches ? -1 : i);
      }));
      sec.classList.add('is-ready');
      sec.addEventListener('shopify:block:select', (e) => { const i = rows.indexOf(e.target.closest('[data-dc-svc-row]')); if (i >= 0) open(i); });
    };


    // Überschrift: nie breiter als ihre Spalte. Verkleinert, bis auch das längste Wort passt (keine Trennung mitten im Wort)
    const fitTitle = (h) => {
      const W = h.clientWidth;
      if (!W) return;
      h.style.fontSize = '';
      h.classList.add('is-fit');
      let fs = parseFloat(getComputedStyle(h).fontSize);
      for (let i = 0; i < 40 && h.scrollWidth > W + 1; i++) { fs *= 0.95; h.style.fontSize = fs.toFixed(2) + 'px'; }
    };
    const fitAll = (root = document) => root.querySelectorAll('.dc-svc__title').forEach(fitTitle);
    if (!window.__dcSvcFit) {
      window.__dcSvcFit = true;
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver((es) => es.forEach((e) => fitTitle(e.target)));
        const watch = (root = document) => root.querySelectorAll('.dc-svc__title').forEach((h) => ro.observe(h));
        document.addEventListener('shopify:section:load', (e) => watch(e.target));
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watch()); else watch();
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fitAll());
      document.addEventListener('shopify:section:load', (e) => fitAll(e.target));
    }

    const init = (root = document) => root.querySelectorAll('[data-dc-svc]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcStats) return;
    window.__dcStats = true;

    // Herkunft: aria-expanded folgt dem Zustand, Escape schließt bis zum nächsten Verlassen
    const bindInfo = (root = document) => root.querySelectorAll('[data-dc-info]:not([data-bound])').forEach((w) => {
      w.dataset.bound = '1';
      const btn = w.querySelector('button');
      const sync = () => btn.setAttribute('aria-expanded', String(w.matches(':hover, :focus-within') && !w.classList.contains('is-closed')));
      const reset = () => { if (!w.matches(':hover, :focus-within')) w.classList.remove('is-closed'); sync(); };
      w.addEventListener('pointerenter', sync);
      w.addEventListener('pointerleave', reset);
      w.addEventListener('focusin', sync);
      w.addEventListener('focusout', () => setTimeout(reset));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && w.matches(':hover, :focus-within')) { w.classList.add('is-closed'); sync(); } });
    });
    document.addEventListener('shopify:section:load', (e) => bindInfo(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindInfo()); else bindInfo();

    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 699px)');
    if (!('IntersectionObserver' in window) || !(window.CSS && CSS.registerProperty)) return;

    const io = new IntersectionObserver((entries) => {
      for (const en of entries) {
        if (!en.isIntersecting) continue;
        io.unobserve(en.target);
        en.target.classList.add('is-run');
      }
    }, { threshold: 0.6 });

    const bind = (root = document) => {
      if (reduce.matches || mobile.matches) return;
      root.querySelectorAll('[data-dc-count]:not(.is-count)').forEach((el) => {
        el.classList.add('is-count');
        el.addEventListener('animationend', () => el.classList.remove('is-count', 'is-run'), { once: true });
        io.observe(el);
      });
    };

    document.addEventListener('shopify:section:load', (e) => bind(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind()); else bind();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcSteps) return;
    window.__dcSteps = true;

    // Szenen der Bildleiste: Schleife, solange die Karte im Bild ist (außerhalb pausiert); zugleich sichtbare Karten versetzt
    const scenes = (sec) => {
      const cards = [...sec.querySelectorAll('.dc-steps__card.has-scene')];
      if (!cards.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      sec.classList.add('is-anim');
      const io = new IntersectionObserver((entries) => {
        entries.filter((e) => !e.isIntersecting).forEach((e) => e.target.classList.remove('is-in'));
        entries.filter((e) => e.isIntersecting).sort((a, b) => cards.indexOf(a.target) - cards.indexOf(b.target)).forEach((e, k) => {
          if (!e.target.style.getPropertyValue('--sd')) e.target.style.setProperty('--sd', (k * 0.45).toFixed(2) + 's');
          e.target.classList.add('is-in');
        });
      }, { threshold: 0.25 });
      cards.forEach((c) => io.observe(c));
    };

    // Einstieg der Bildleiste: jede Karte einmal, sobald sie ins Bild kommt; zugleich sichtbare Karten nacheinander
    const reveal = (sec) => {
      const cards = [...sec.querySelectorAll('.dc-steps__card')];
      if (!cards.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !document.body.classList.contains('dc-m-reveal')) return;
      sec.classList.add('is-rv');
      const io = new IntersectionObserver((entries) => {
        entries.filter((e) => e.isIntersecting).sort((a, b) => cards.indexOf(a.target) - cards.indexOf(b.target)).forEach((e, k) => {
          e.target.style.setProperty('--rv-d', (k * 0.12).toFixed(2) + 's');
          e.target.classList.add('is-shown');
          io.unobserve(e.target);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
      cards.forEach((c) => io.observe(c));
    };

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;
      reveal(sec);
      scenes(sec);
      const tabs = [...sec.querySelectorAll('[data-dc-steps-tab]')];
      if (!tabs.length) return;
      const panel = sec.querySelector('.dc-steps__panel');
      const big = sec.querySelector('[data-dc-steps-big]');
      const ttl = sec.querySelector('[data-dc-steps-ptitle]');
      const txt = sec.querySelector('[data-dc-steps-ptext]');
      const prev = sec.querySelector('[data-dc-steps-prev]');
      const next = sec.querySelector('[data-dc-steps-next]');
      const bar = sec.querySelector('.dc-steps__tabs');
      let cur = 0;

      const go = (i, focus) => {
        i = Math.max(0, Math.min(tabs.length - 1, i));
        if (i !== cur) { panel.classList.remove('is-swap'); void panel.offsetWidth; panel.classList.add('is-swap'); }
        cur = i;
        tabs.forEach((t, k) => {
          t.classList.toggle('is-on', k === i);
          t.classList.toggle('is-done', k <= i);
          t.setAttribute('aria-selected', String(k === i));
          t.tabIndex = k === i ? 0 : -1;
        });
        const t = tabs[i];
        big.textContent = t.dataset.no;
        ttl.textContent = t.dataset.title;
        txt.textContent = t.dataset.text;
        panel.setAttribute('aria-labelledby', t.id);
        bar.style.setProperty('--p', tabs.length > 1 ? (i / (tabs.length - 1)).toFixed(3) : 0);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === tabs.length - 1;
        if (focus) t.focus();
      };

      tabs.forEach((t, k) => {
        t.addEventListener('click', () => go(k));
        t.addEventListener('keydown', (e) => {
          const map = { ArrowRight: cur + 1, ArrowLeft: cur - 1, Home: 0, End: tabs.length - 1 };
          if (e.key in map) { e.preventDefault(); go(map[e.key], true); }
        });
      });
      if (prev) prev.addEventListener('click', () => go(cur - 1));
      if (next) next.addEventListener('click', () => go(cur + 1));
      sec.addEventListener('shopify:block:select', (e) => { const k = tabs.indexOf(e.target.closest('[data-dc-steps-tab]')); if (k >= 0) go(k); });
      sec.classList.add('is-ready');
      go(0);
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-steps]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-team"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcTm) return;
    window.__dcTm = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    // Überschrift: nie breiter als ihre Spalte, verkleinert bis auch das längste Wort passt
    const fitTitle = (h) => {
      const W = h.clientWidth;
      if (!W) return;
      h.style.fontSize = '';
      h.classList.add('is-fit');
      let fs = parseFloat(getComputedStyle(h).fontSize);
      for (let i = 0; i < 40 && h.scrollWidth > W + 1; i++) { fs *= 0.95; h.style.fontSize = fs.toFixed(2) + 'px'; }
    };
    const ro = 'ResizeObserver' in window ? new ResizeObserver((es) => es.forEach((e) => fitTitle(e.target))) : null;

    const bindCard = (card) => {
      const flip = card.querySelector('[data-dc-tm-flip]');
      if (!flip) return;
      const video = card.querySelector('video');
      if (video) { video.muted = true; video.defaultMuted = true; video.playsInline = true; }
      let pinned = false;
      let seen = false;
      const set = (on) => {
        card.classList.toggle('is-work', on);
        flip.setAttribute('aria-pressed', String(on));
        if (!video) return;
        if (on && seen && !reduce.matches) { if (video.preload === 'none') video.preload = 'auto'; const p = video.play(); if (p && p.catch) p.catch(() => {}); }
        else video.pause();
      };
      card.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && fine.matches) set(true); });
      card.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && fine.matches && !pinned) set(false); });
      card.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) set(true); });
      card.addEventListener('focusout', (e) => { if (!card.contains(e.relatedTarget) && !pinned) set(false); });
      flip.addEventListener('click', () => { pinned = !card.classList.contains('is-work'); set(pinned); });
      if (!('IntersectionObserver' in window)) { seen = true; return; }
      new IntersectionObserver(([en]) => { seen = en.isIntersecting; set(card.classList.contains('is-work')); }).observe(card);
      if (fine.matches || reduce.matches) return;
      // Handy: kurz das Gesicht zeigen, dann einmal die Arbeit
      const once = new IntersectionObserver(([en]) => {
        if (!en.isIntersecting) return;
        once.disconnect();
        setTimeout(() => { if (!pinned) set(true); }, 900);
      }, { threshold: 0.6 });
      once.observe(card);
    };

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;
      const h = sec.querySelector('.dc-tm__title');
      if (h) { fitTitle(h); if (ro) ro.observe(h); if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fitTitle(h)); }
      sec.querySelectorAll('[data-dc-tm-card]').forEach(bindCard);
    };

    const init = (root = document) => root.querySelectorAll('[data-dc-tm]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-work"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcWork) return;
    window.__dcWork = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Kopien 2 bis 4 je Band: 2 ist die Kachel selbst (mit Video), 3 und 4 kommen aus dem Standbild-template
    const fill = (sec) => {
      sec.querySelectorAll('.dc-work__row').forEach((row) => {
        const set = row.querySelector('.dc-work__set');
        const tpl = row.querySelector('template[data-dc-work-poster]');
        if (!set || !tpl) return;
        const mute = (el) => { el.setAttribute('aria-hidden', 'true'); el.inert = true; el.setAttribute('inert', ''); return el; };
        const poster = () => { const d = document.createElement('div'); d.className = 'dc-work__set'; d.appendChild(tpl.content.cloneNode(true)); return mute(d); };
        row.append(mute(set.cloneNode(true)), poster(), poster());
        tpl.remove();
      });
    };

    const bind = (sec) => {
      if (sec.__dcBound) return;
      sec.__dcBound = true;
      fill(sec);
      const videos = [...sec.querySelectorAll('video')];
      // Fehlt die kleinere Fassung (Fehler an der letzten Quelle), die Originalquelle nehmen
      videos.forEach((v) => {
        const fb = v.dataset.dcFb, last = v.querySelector('source:last-of-type');
        if (fb && last) last.addEventListener('error', () => { if (v.currentSrc !== fb) { v.querySelectorAll('source').forEach((x) => x.remove()); v.src = fb; v.load(); } }, { once: true });
      });
      // Stumm erzwingen, sonst blockiert der Browser das automatische Abspielen
      videos.forEach((v) => { v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('muted', ''); });
      const st = { visible: false, key: false };

      const sync = () => {
        const live = st.visible && !document.hidden;
        sec.classList.toggle('is-live', live);
        sec.classList.toggle('is-held', st.key);
        videos.forEach((v) => {
          // Schon eine halbe Bildschirmhöhe vorher laden, damit das Video beim Hereinscrollen läuft (Paket 15)
          if (v.__in && !reduce.matches && v.preload === 'none') v.preload = 'auto';
          if (live && v.__in && !reduce.matches) {
            if (v.paused) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
          } else if (!v.paused) v.pause();
        });
      };

      // Nur Videos abspielen, deren Kachel gerade im Bild ist (etwas Vorlauf, damit sie schon laufen, wenn sie hereinkommen)
      if ('IntersectionObserver' in window) {
        const vio = new IntersectionObserver((es) => { es.forEach((e) => { e.target.__in = e.isIntersecting; }); sync(); }, { rootMargin: '50% 25% 50% 25%' });
        videos.forEach((v) => vio.observe(v));
        new IntersectionObserver(([e]) => { st.visible = e.isIntersecting; sync(); }, { threshold: 0.05 }).observe(sec);
      } else { videos.forEach((v) => { v.__in = true; }); st.visible = true; sync(); }

      // Kein Halt beim Zeigen mit der Maus. Mit der Tastatur halten die Bänder, solange eine Kachel den Fokus hat
      sec.addEventListener('focusin', (e) => { st.key = e.target.matches(':focus-visible') && !!e.target.closest('.dc-work__rows'); sync(); });
      sec.addEventListener('focusout', (e) => { if (!sec.contains(e.relatedTarget)) { st.key = false; sync(); } });
      document.addEventListener('visibilitychange', sync);
      reduce.addEventListener('change', sync);
    };


    // Überschrift: nie breiter als ihre Spalte. Verkleinert, bis auch das längste Wort passt (keine Trennung mitten im Wort)
    const fitTitle = (h) => {
      const W = h.clientWidth;
      if (!W) return;
      h.style.fontSize = '';
      h.classList.add('is-fit');
      let fs = parseFloat(getComputedStyle(h).fontSize);
      for (let i = 0; i < 40 && h.scrollWidth > W + 1; i++) { fs *= 0.95; h.style.fontSize = fs.toFixed(2) + 'px'; }
    };
    const fitAll = (root = document) => root.querySelectorAll('.dc-work__title').forEach(fitTitle);
    if (!window.__dcWorkFit) {
      window.__dcWorkFit = true;
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver((es) => es.forEach((e) => fitTitle(e.target)));
        const watch = (root = document) => root.querySelectorAll('.dc-work__title').forEach((h) => ro.observe(h));
        document.addEventListener('shopify:section:load', (e) => watch(e.target));
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watch()); else watch();
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fitAll());
      document.addEventListener('shopify:section:load', (e) => fitAll(e.target));
    }

    const init = (root = document) => root.querySelectorAll('[data-dc-work]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-world-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dcWd) return;
    window.__dcWd = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const items = new Set();
    let raf = 0;

    // Fenster (--wd-p) und Parallax (--wd-par) aus der Lage der Section im Bildschirm
    const tick = () => {
      raf = 0;
      const vh = window.innerHeight || 1;
      items.forEach((it) => {
        if (!it.near || reduce.matches) return;
        const r = it.el.getBoundingClientRect();
        if (it.reveal) {
          const p = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.75)));
          const e = 1 - Math.pow(1 - p, 3);
          if (Math.abs(e - it.p) > 0.001) { it.p = e; it.el.style.setProperty('--wd-p', e.toFixed(4)); }
        }
        if (it.parallax) {
          const c = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
          const v = Math.max(-1, Math.min(1, c));
          if (Math.abs(v - it.par) > 0.002) { it.par = v; it.el.style.setProperty('--wd-par', v.toFixed(4)); }
        }
      });
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(tick); };

    // Überschrift: nie breiter als ihre Spalte, verkleinert bis auch das längste Wort passt
    const fit = (h) => {
      const W = h.clientWidth;
      if (!W) return;
      h.style.fontSize = '';
      h.classList.add('is-fit');
      let fs = parseFloat(getComputedStyle(h).fontSize);
      for (let i = 0; i < 40 && h.scrollWidth > W + 1; i++) { fs *= 0.95; h.style.fontSize = fs.toFixed(2) + 'px'; }
    };
    const ro = 'ResizeObserver' in window ? new ResizeObserver((es) => es.forEach((e) => fit(e.target))) : null;

    // Countdown bis zum Datum (JJJJ-MM-TT, Ortszeit). Vorbei: Countdown verschwindet
    const countdown = (box) => {
      const m = (box.dataset.dcWdCount || '').match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
      if (!m) return;
      const end = new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)).getTime();
      const u = {}; box.querySelectorAll('[data-u]').forEach((b) => { u[b.dataset.u] = b; });
      const pad = (n) => String(n).padStart(2, '0');
      const step = () => {
        const left = end - Date.now();
        if (left <= 0) { box.hidden = true; clearInterval(box.__t); return; }
        const s = Math.floor(left / 1000);
        u.d.textContent = pad(Math.floor(s / 86400)); u.h.textContent = pad(Math.floor(s / 3600) % 24);
        u.m.textContent = pad(Math.floor(s / 60) % 60); u.s.textContent = pad(s % 60);
        box.hidden = false;
      };
      step();
      box.__t = setInterval(step, 1000);
    };

    const bind = (el) => {
      if (el.__dcBound) return;
      el.__dcBound = true;
      const it = { el, p: -1, par: 9, near: false, reveal: el.classList.contains('dc-wd--reveal'), parallax: el.classList.contains('dc-wd--parallax') };
      items.add(it);
      const title = el.querySelector('.dc-wd__title');
      if (title) { fit(title); if (ro) ro.observe(title); if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fit(title)); }
      el.querySelectorAll('[data-dc-wd-count]').forEach(countdown);
      const video = el.querySelector('[data-dc-wd-video]');
      if (video) { video.muted = true; video.defaultMuted = true; video.playsInline = true; }
      // Nach dem Absenden des Formulars direkt zur Rückmeldung
      if (el.querySelector('.dc-wd__soon-ok, .dc-wd__soon-err')) el.scrollIntoView({ block: 'center' });
      // Bewegung reduzieren: Video bleibt beim Poster stehen. Ohne IntersectionObserver läuft es einfach.
      if (reduce.matches || !('IntersectionObserver' in window)) {
        el.classList.add('is-in');
        if (video && !reduce.matches) { const p = video.play(); if (p && p.catch) p.catch(() => {}); }
        return;
      }
      el.classList.add('is-js');
      new IntersectionObserver(([e]) => { it.near = e.isIntersecting; schedule(); }, { rootMargin: '20% 0px 20% 0px' }).observe(el);
      new IntersectionObserver(([e]) => {
        el.classList.toggle('is-live', e.isIntersecting);
        if (e.isIntersecting) el.classList.add('is-in');
        if (video) { if (e.isIntersecting && !reduce.matches) { const p = video.play(); if (p && p.catch) p.catch(() => {}); } else video.pause(); }
      }, { threshold: 0.2 }).observe(el);
    };

    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    const init = (root = document) => root.querySelectorAll('[data-dc-wd]').forEach(bind);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) => items.forEach((it) => { if (e.target.contains(it.el)) items.delete(it); }));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    // Überschrift so weit verkleinern, bis das längste Wort in die Spalte passt (wie in den DC-Sections)
    const fit = (h) => {
      const W = h.clientWidth;
      if (!W) return;
      h.style.fontSize = '';
      h.classList.add('is-fit');
      let fs = parseFloat(getComputedStyle(h).fontSize);
      for (let i = 0; i < 40 && h.scrollWidth > W + 1; i++) { fs *= 0.95; h.style.fontSize = fs.toFixed(2) + 'px'; }
    };
    const init = () => document.querySelectorAll('.dc-page__title').forEach((h) => {
      fit(h);
      if ('ResizeObserver' in window) new ResizeObserver(() => fit(h)).observe(h);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fit(h));
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
